export default () => {
  $(document).on('click', '[data-back-to-top], [data-mobile-pagination-back-to-top]', () => {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
  });

  $(window).on('scroll', () => {
    if ($(window).scrollTop() > $('.shopify-section.header').height()) {
      $('[data-back-to-top]').addClass('active');

      window.setTimeout(() => {
        $('[data-back-to-top]').addClass('visible');
      });
    } else {
      $('[data-back-to-top]').removeClass('active');
      $('[data-back-to-top]').removeClass('visible');
    }
  });
};
